[
  {
    "value": "0",
    "label": "품사없음",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "1",
    "label": "명사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "2",
    "label": "대명사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "3",
    "label": "수사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "4",
    "label": "조사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "5",
    "label": "동사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "6",
    "label": "형용사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "7",
    "label": "관형사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "8",
    "label": "부사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "9",
    "label": "감탄사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "10",
    "label": "접사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "11",
    "label": "의존명사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "12",
    "label": "보조동사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "13",
    "label": "보조형용사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "14",
    "label": "어미",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "15",
    "label": "관형사·명사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "16",
    "label": "수사·관형사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "17",
    "label": "명사·부사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "18",
    "label": "감탄사·명사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "19",
    "label": "대명사·부사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "20",
    "label": "대명사·감탄사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "21",
    "label": "동사·형용사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "22",
    "label": "관형사·감탄사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "23",
    "label": "부사·감탄사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "24",
    "label": "의존명사·조사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "25",
    "label": "수사·관형사·명사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "26",
    "label": "대명사·관형사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "n",
    "label": "명사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "a",
    "label": "형용사 (a)",
    "lang": [
      "en"
    ]
  },
  {
    "value": "s",
    "label": "형용사 (s)",
    "lang": [
      "en"
    ]
  },
  {
    "value": "v",
    "label": "동사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "r",
    "label": "부사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "vi",
    "label": "자동사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "vt",
    "label": "타동사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "p",
    "label": "대명사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "int",
    "label": "감탄사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "prep",
    "label": "전치사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "aux",
    "label": "조동사",
    "lang": [
      "en"
    ]
  },
  {
    "value": "INJEONG",
    "label": "어인정",
    "lang": [
      "ko", "en"
    ]
  }
]
